export const CountryItem = ({ code, name, size = 24, hideName = false }: { code: string | TrustedHTML; name: string; size?: number; hideName?: boolean }) => {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 15 }}>
      <span
        dangerouslySetInnerHTML={{ __html: code }}
        style={{
          display: 'inline-block',
          width: size,
          height: size,
          borderRadius: '50%',
          overflow: 'hidden',
          lineHeight: 0
        }}
      />
      {!hideName && <div style={{ color: '#737373' }}>{name}</div>}
    </div>
  )
}
